"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.NavContainer = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../../Layout");

var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      header = _ref$theme.header;
  return {
    background: colors[header.secondary.background],
    borderBottom: header.secondary.border === 'none' ? header.border : "1px solid ".concat(colors[header.secondary.border])
  };
});
exports.Wrapper = Wrapper;
var NavContainer = (0, _styled.default)(_Layout.Container)({
  display: 'flex',
  justifyContent: 'center',
  minHeight: '48px',
  alignItems: 'center',
  flexDirection: 'row',
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
    height: '0'
  }
});
exports.NavContainer = NavContainer;